<template>
 <!-- Iconex/Light/Time Circle, exported from Figma node 6627:150561 (Client
      Review - Waitlist Cards, 2026-09-02). Geometry is the export verbatim.

      Two adaptations from the export, both load-bearing:

        * stroke="currentColor" rather than the exported stroke="white". The
          standby button inverts — magenta on transparent when the attendee can
          join, white on magenta once they have — so a hardcoded stroke would
          vanish against one of its own two states.

        * No width/height attributes. The callers size it (14px on the cards),
          and a fixed intrinsic size on an icon that appears at several scales
          is how the seat icon ended up with 10.167 × 11.611 hardcoded at every
          call site.

      NOT the existing clock.vue: that one is a FILLED 20x20 glyph, and this is a
      thin stroked outline matching seat.vue's weight. A name match is not a
      glyph match. -->
 <svg
  role="img"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 13.1875 13.1875"
  fill="none"
  aria-label="An icon of a clock face"
 >
  <circle cx="6.59375" cy="6.59375" r="6.09375" stroke="currentColor" />
  <path
   d="M6.59375 2.77051V6.30555C6.59375 6.48418 6.68905 6.64925 6.84375 6.73856L9.19644 8.09689"
   stroke="currentColor"
   stroke-linecap="round"
  />
 </svg>
</template>
